export default __webpack_public_path__ + "static/media/logo_ugtehagro.2dfc6b73.webp";